<mat-card class="pageWrapper">
    <mat-card-content>
        <div class="mat-elevation-z8 section-wrap">
            <div class="page-title-wrap">
                <h2 class="page-title">
                    Course Assessment Mapping
                </h2>
            </div>
            <div class="searchWrap">
                <div class="searchInnerDiv">
                    <mat-form-field appearance="outline" class="fullWidth">
                        <mat-label>Test</mat-label>
                        <input matInput (keyup)="fieldListenerHome()" name="test" [(ngModel)]="courseFilterValues.test">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
                <div class="searchInnerDiv">
                    <mat-form-field appearance="outline" class="fullWidth">
                        <mat-label>Topic</mat-label>
                        <input matInput (keyup)="fieldListenerHome()" name="topic"
                            [(ngModel)]="courseFilterValues.topic">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
                <div class="searchInnerDiv">
                    <mat-form-field appearance="outline" class="fullWidth">
                        <mat-label>Course ID</mat-label>
                        <input matInput (keyup)="fieldListenerHome()" name="courseID"
                            [(ngModel)]="courseFilterValues.courseID">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>

            </div>
            <div class="buttonWrap">
                <button mat-raised-button class="button-style" (click)="reset()">Reset</button>
            </div>
            <div class="mat-elevation-z8">
                <div class="tableWrap">
                    <table mat-table [dataSource]="dataSource" matSort>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef > </th>
                            <td mat-cell *matCellDef="let row">
                                <a (click)="editTopicCourse(row)">
                                    <mat-icon>edit</mat-icon>
                                </a> 
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="test">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Test Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.test}} </td>
                        </ng-container>
                        <ng-container matColumnDef="topic">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Topic </th>
                            <td mat-cell *matCellDef="let element"> {{element.topic}} </td>
                        </ng-container>
                        <ng-container matColumnDef="courseID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Course Id </th>
                            <td mat-cell *matCellDef="let element"> {{element.courseName}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>

        </div>
    </mat-card-content>
</mat-card>
<app-modal 
  [showModal]="showModal" [TopicCourseDetails]="selectedCourseTopicRow" (closed)="onPopupClosed($event)"></app-modal>